import { createFileRoute } from '@tanstack/react-router'

import { OrgSettingsSection } from '@/features/organization/org-settings-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/')({
  component: GeralTab,
})

function GeralTab() {
  const { currentOrgId } = useAuth()
  return <OrgSettingsSection orgId={currentOrgId} />
}
